import { differenceInDays, parseISO } from "date-fns";

/** Matches public.rt_races.chamber CHECK (010_race_tracker_tables.sql). */
export const RT_CHAMBER_VALUES = [
  "U.S. House",
  "U.S. Senate",
  "State Senate",
  "State House",
  "Governor",
  "Other",
];

/**
 * Map CSV "office" / chamber text to a valid rt_races.chamber value.
 * SMG mapped sheets often use House, Senate, Downballot, Issue, etc.
 * @param {unknown} raw
 * @returns {string|null} null when empty
 */
export function normalizeChamber(raw) {
  if (raw == null) return null;
  const s = String(raw).trim();
  if (!s) return null;
  if (RT_CHAMBER_VALUES.includes(s)) return s;

  const lower = s.toLowerCase();
  /** @type {Record<string, string>} */
  const alias = {
    house: "U.S. House",
    "u.s. house": "U.S. House",
    "us house": "U.S. House",
    senate: "U.S. Senate",
    "u.s. senate": "U.S. Senate",
    "us senate": "U.S. Senate",
    "state senate": "State Senate",
    "state house": "State House",
    governor: "Governor",
    gov: "Governor",
    downballot: "Other",
    issue: "Other",
    "non-political": "Other",
    "audit program": "Other",
    government: "Other",
    national: "Other",
  };
  if (alias[lower]) return alias[lower];

  if (lower.includes("governor")) return "Governor";
  if (lower.includes("state senate")) return "State Senate";
  if (lower.includes("state house") || lower.includes("state assembly")) return "State House";

  return "Other";
}

/**
 * Returns staleness info for a sweep date.
 * @param {string|null} dateStr
 * @returns {{ days: number|null, level: 'ok'|'warning'|'danger'|'critical'|'none' }}
 */
export function getSweepStaleness(dateStr) {
  if (!dateStr) return { days: null, level: "none" };
  const days = differenceInDays(new Date(), parseISO(dateStr));
  if (days > 30) return { days, level: "critical" };
  if (days > 14) return { days, level: "danger" };
  if (days > 7)  return { days, level: "warning" };
  return { days, level: "ok" };
}

export const SWEEP_LEVEL_STYLES = {
  ok:       { dot: "bg-emerald-500", text: "text-emerald-600", badge: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  warning:  { dot: "bg-yellow-400",  text: "text-yellow-600",  badge: "bg-yellow-50 text-yellow-700 border-yellow-200" },
  danger:   { dot: "bg-orange-500",  text: "text-orange-600",  badge: "bg-orange-50 text-orange-700 border-orange-200" },
  critical: { dot: "bg-red-500",     text: "text-red-600",     badge: "bg-red-50 text-red-700 border-red-200" },
  none:     { dot: "bg-gray-300",    text: "text-gray-400",    badge: "bg-gray-50 text-gray-400 border-gray-200" },
};